var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSketchLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "394px",
    height: "356px",
    viewBox: "0 0 394 356",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sketch-symbol") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sketch-symbol",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FDB300",
    points: "85.790323 11.7151549 196.602823 0 307.415323 11.7151549 393.205645 126.881084 196.602823 355.823009 0 126.881084"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 126.881084)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EA6C00",
    points: "79.634 0 196.603 228.942 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EA6C00",
    transform: "translate(294.903968, 114.471000) scale(-1, 1) translate(-294.903968, -114.471000) ",
    points: "276.236468 0 393.205468 228.942 196.602468 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FDAD00",
    points: "79.634 0 313.572 0 196.603 228.942"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FDD231",
    points: "196.603 0 85.79 11.715 79.634 126.881"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FDD231",
    transform: "translate(255.086896, 63.440500) scale(-1, 1) translate(-255.086896, -63.440500) ",
    points: "313.571396 0 202.758396 11.715 196.602396 126.881"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FDAD00",
    transform: "translate(350.310468, 69.298000) scale(-1, 1) translate(-350.310468, -69.298000) ",
    points: "307.414968 126.881 393.205968 11.715 387.048968 126.881"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FDAD00",
    points: "0 126.881 85.79 11.715 79.634 126.881"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FEEEB7",
    points: "196.603 0 79.634 126.881 313.572 126.881"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketchLogo);
export default __webpack_public_path__ + "static/media/Sketch_Logo.99f9ecb07dc0334ba2b7559c56753e82.svg";
export { ForwardRef as ReactComponent };